import { Typography } from '@material-ui/core';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { select, useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import Prompt from '../../../../components/Prompt/Prompt';
import TransitionProgressPrompt from '../../../../components/TransitionProgressPrompt/TransitionProgressPrompt';
import createSingleton from '../../../../hooks/useSingleton';

import {
  TXTCLI_Almost_done,
  TXTCLI_Once_you_depositX_youXll_be_go_ELL,
  TXTWCL_Almost_there,
  TXTWCL_Continue,
  TXTWCL_Continue_to_deposit,
  TXTWCL_Make_your_first_deposit_and_cl_ELL,
  TXTWCL_Next_upXX
} from './DepositTransitionScreen.messages.json';

const [getValue, setValue] = createSingleton(false);

const DepositTransitionScreen: React.FC = () => {
  const { data } = useWizardContext();
  const { rmfPassed, paySystemDetails = {} } = data;
  const isSwcSignupRmfEcoTransitionTwo = useFeature(FeatureFlag.SwcSignupRmfEcoEransitionTwo);
  const swcDisableRmfTransition = useFeature(FeatureFlag.SwcDisableRmfTransition);
  const swcRMFConfirmationEnabled = useFeature(FeatureFlag.SwcRMFTransition);
  const isFrance = useSelector(select.cms.getSiteId) === Sites.FRA;
  const hasBeenShown = getValue();
  const isSwcSignupRmfEcoTransitionTwoShown =
    !swcDisableRmfTransition &&
    rmfPassed &&
    isSwcSignupRmfEcoTransitionTwo &&
    !hasBeenShown &&
    !Object.keys(paySystemDetails).length;
  const isCelebrationPromptShown =
    !swcDisableRmfTransition &&
    !isSwcSignupRmfEcoTransitionTwo &&
    !isFrance &&
    rmfPassed &&
    !Object.keys(paySystemDetails).length &&
    !hasBeenShown;

  if (swcRMFConfirmationEnabled) {
    return null;
  }
  if (isSwcSignupRmfEcoTransitionTwoShown) {
    return (
      <TransitionProgressPrompt
        title={{ translation: TXTCLI_Almost_done }}
        primaryButton={{ translation: TXTWCL_Continue_to_deposit }}
        onPrimaryButtonClick={() => setValue(!hasBeenShown)}
      >
        <Typography>
          <Translation {...TXTCLI_Once_you_depositX_youXll_be_go_ELL} />
        </Typography>
      </TransitionProgressPrompt>
    );
  }
  if (isCelebrationPromptShown) {
    return (
      <Prompt
        title={{ translation: TXTWCL_Almost_there }}
        secondaryTitle={{ translation: TXTWCL_Next_upXX }}
        primaryButton={{
          translation: TXTWCL_Continue
        }}
        onPrimaryButtonClick={() => setValue(!hasBeenShown)}
        noCloseButton
        variant="celebration"
      >
        <Typography>
          <Translation {...TXTWCL_Make_your_first_deposit_and_cl_ELL} />
        </Typography>
      </Prompt>
    );
  }
  return null;
};

export default DepositTransitionScreen;
